<template>
  <div class="invoice-payment-info">
    <slot name="beforeForm" />

    <base-date-picker
      :date="createdAt"
      :is-disabled="true"
      placeholder="Created at"
    />
  </div>
</template>

<script>
  import { isNum } from '@/utils';

  // TODO: Translate component
  export default {
    props: {
      invoice: {
        type: Object,
        default: undefined,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      createdAt: '',
    }),
    created() {
      if (isNum(this.invoice?.id)) {
        this.extractInvoiceData(this.invoice);
      }
    },
    watch: {
      invoice(nextInvoice) {
        if (isNum(nextInvoice?.id)) {
          this.extractInvoiceData(nextInvoice);
        }
      },
    },
    methods: {
      clear() {
        this.createdAt = '';
      },
      extractInvoiceData({ created_at }) {
        this.createdAt = created_at;
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

.invoice-payment-info {
  padding: $spacing-xl;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid map.get($colors, grey, lighten-2);
}
</style>
